import { CaretUpIcon, CaretDownIcon } from "@phosphor-icons/react";
import { CoinRow } from "./CoinRow";

const cols = [
  { key: "rank", label: "#", sortable: false, align: "right", cls: "w-10" },
  { key: "name", label: "Token", sortable: false, align: "left" },
  { key: "price", label: "Price", sortable: false, align: "right" },
  { key: "change", label: "24h", sortable: true, align: "right" },
  { key: "volume", label: "Volume", sortable: true, align: "right", cls: "hidden md:table-cell" },
  { key: "marketCap", label: "MCap", sortable: true, align: "right", cls: "hidden lg:table-cell" },
  { key: "liquidity", label: "Liquidity", sortable: true, align: "right", cls: "hidden lg:table-cell" },
  { key: "age", label: "Age", sortable: true, align: "right", cls: "hidden sm:table-cell" },
  { key: "momentum", label: "Momentum", sortable: true, align: "center", cls: "hidden md:table-cell" },
  { key: "velocity", label: "1h ×", sortable: true, align: "center", cls: "hidden lg:table-cell" },
  { key: "conviction", label: "👀 Conv", sortable: true, align: "center", cls: "hidden xl:table-cell" },
  { key: "score", label: "Degen Score", sortable: true, align: "center" },
  { key: "flags", label: "Signals", sortable: false, align: "left", cls: "hidden xl:table-cell" },
  { key: "watch", label: "", sortable: false, align: "center" },
];

export const CoinTable = ({ coins, sort, order, onSort }) => {
  return (
    <div className="border border-white/10 bg-card overflow-x-auto">
      <table className="w-full border-collapse min-w-[720px]">
        <thead>
          <tr className="border-b border-white/10 bg-white/[0.02]">
            {cols.map((c) => {
              const active = sort === c.key;
              return (
                <th
                  key={c.key}
                  data-testid={c.sortable ? `sort-${c.key}` : undefined}
                  onClick={() => c.sortable && onSort(c.key)}
                  className={`px-3 py-3 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground ${
                    c.align === "right" ? "text-right" : c.align === "center" ? "text-center" : "text-left"
                  } ${c.cls || ""} ${c.sortable ? "cursor-pointer hover:text-white select-none" : ""}`}
                >
                  <span className={`inline-flex items-center gap-1 ${c.align === "right" ? "flex-row-reverse" : ""}`}>
                    {c.label}
                    {active && (order === "desc" ? <CaretDownIcon size={12} weight="bold" className="text-neon" /> : <CaretUpIcon size={12} weight="bold" className="text-neon" />)}
                  </span>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {coins.map((coin, i) => (
            <CoinRow key={coin.address} coin={coin} rank={i + 1} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
